import { apiRequest } from '../api/client';
import { endpoints } from '../api/endpoints';

// Cache for metadata
const cache = {
    morphologies: null,
    instabilities: null
};

// Polymers
export function getAllPolymers() {
    return apiRequest(endpoints.MetadataPolymers, { method: 'GET' });
}
export function createPolymer(data) {
    return apiRequest(endpoints.MetadataPolymers, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}
export function updatePolymer(id, data) {
    return apiRequest(endpoints.MetadataPolymer(id), {
        method: 'PUT',
        body: JSON.stringify(data),
    });
}
export function deletePolymer(id) {
    return apiRequest(endpoints.MetadataPolymer(id), { method: 'DELETE' });
}
export function getPolymerByCas(cas) {
    return apiRequest(endpoints.MetadataPolymerByCas(cas), { method: 'GET' });
}

// Solvents
// Additives (nanoparticles, salts, drugs, fillers, ...)
export function getAllAdditives() {
    return apiRequest(endpoints.MetadataAdditives, { method: 'GET' });
}
export function createAdditive(data) {
    return apiRequest(endpoints.MetadataAdditives, { method: 'POST', body: JSON.stringify(data) });
}
export function updateAdditive(id, data) {
    return apiRequest(endpoints.MetadataAdditive(id), { method: 'PUT', body: JSON.stringify(data) });
}
export function deleteAdditive(id) {
    return apiRequest(endpoints.MetadataAdditive(id), { method: 'DELETE' });
}

// Monomers (what copolymers are made of)
export function getAllMonomers() {
    return apiRequest(endpoints.MetadataMonomers, { method: 'GET' });
}
export function createMonomer(data) {
    return apiRequest(endpoints.MetadataMonomers, { method: 'POST', body: JSON.stringify(data) });
}
export function updateMonomer(id, data) {
    return apiRequest(endpoints.MetadataMonomer(id), { method: 'PUT', body: JSON.stringify(data) });
}
export function deleteMonomer(id) {
    return apiRequest(endpoints.MetadataMonomer(id), { method: 'DELETE' });
}

export function getAllSolvents() {
    return apiRequest(endpoints.MetadataSolvents, { method: 'GET' });
}
export function createSolvent(data) {
    return apiRequest(endpoints.MetadataSolvents, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}
export function updateSolvent(id, data) {
    return apiRequest(endpoints.MetadataSolvent(id), {
        method: 'PUT',
        body: JSON.stringify(data),
    });
}
export function deleteSolvent(id) {
    return apiRequest(endpoints.MetadataSolvent(id), { method: 'DELETE' });
}
export function getSolventByCas(cas) {
    return apiRequest(endpoints.MetadataSolventByCas(cas), { method: 'GET' });
}

// Morphologies
export function getAllMorphologies() {
    if (cache.morphologies) return cache.morphologies;
    cache.morphologies = apiRequest(endpoints.MetadataMorphologies, { method: 'GET' });
    return cache.morphologies;
}
export function createMorphology(data) {
    return apiRequest(endpoints.MetadataMorphologies, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}
export function updateMorphology(id, data) {
    return apiRequest(endpoints.MetadataMorphology(id), {
        method: 'PUT',
        body: JSON.stringify(data),
    });
}
export function deleteMorphology(id) {
    return apiRequest(endpoints.MetadataMorphology(id), { method: 'DELETE' });
}

// Instabilities
export function getAllInstabilities() {
    if (cache.instabilities) return cache.instabilities;
    cache.instabilities = apiRequest(endpoints.MetadataInstabilities, { method: 'GET' });
    return cache.instabilities;
}
export function createInstability(data) {
    return apiRequest(endpoints.MetadataInstabilities, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}
export function updateInstability(id, data) {
    return apiRequest(endpoints.MetadataInstability(id), {
        method: 'PUT',
        body: JSON.stringify(data),
    });
}
export function deleteInstability(id) {
    return apiRequest(endpoints.MetadataInstability(id), { method: 'DELETE' });
}

// Units
export function getAllUnits() {
    return apiRequest(endpoints.MetadataUnits, { method: 'GET' });
}
export function createUnit(data) {
    return apiRequest(endpoints.MetadataUnits, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}
export function updateUnit(id, data) {
    return apiRequest(endpoints.MetadataUnit(id), {
        method: 'PUT',
        body: JSON.stringify(data),
    });
}
export function deleteUnit(id) {
    return apiRequest(endpoints.MetadataUnit(id), { method: 'DELETE' });
}
